<template>
  <section id="main-wrap" class="pure-g">  
    <div id="main-col" class="pure-u-3-5">
      <div id="share-screenshot"></div>
      <div id="grape-capture-wrap"></div>
    </div>
  </section>
</template>

<script>
  /* global $ */
  import db from './firebaseInit'
  import Grape from './Grape.vue'
  import html2canvas from 'html2canvas'

  export default {
    name: 'view-grape',
    data () {
      return {
        grapes: [],
        author: null,
        title: null,
        image: null,
        id: null,
        grapeSource: null,
        description: null,
        createdTimestamp: null,
        updatedTimestamp: null
      }
    },
    metaInfo () {
      return {
        title: this.title,
        meta: [
          { name: 'description', content: this.description },
          { itemprop: 'name', content: this.title },
          { itemprop: 'description', content: this.description },
          { itemprop: 'image', content: this.image },
          { name: 'twitter:card', content: 'summary' },
          { name: 'twitter:site', content: '@grapevine' },
          { name: 'twitter:title', content: this.title },
          { name: 'twitter:description', content: this.description },
          { name: 'twitter:image:src', content: this.image },
          { vmid: 'og:title', property: 'og:title', content: this.title },
          { vmid: 'og:type', property: 'og:title', content: 'article' },
          { vmid: 'og:url', property: 'og:url', content: 'https://atgrapevine.com/%23/view-grape/' + this.id },
          { vmid: 'og:image', property: 'og:image', content: this.image },
          { vmid: 'og:description', property: 'og:description', content: this.description },
          { vmid: 'og:site_name', property: 'og:site_name', content: 'Grapevine' },
          { vmid: 'article:published_time', property: 'article:published_time', content: this.createdTimestamp },
          { vmid: 'article:modified_time', property: 'article:modified_time', content: this.updatedTimestamp }
        ]
      }
    },
    created () {
      this.fetchData()
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
        let vm = this
        this.grapes = []
        db.collection('grapes').where('id', '==', this.$route.params.grapeID).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            console.log(doc.id, ' => ', doc.data())
            var grapeData = doc.data()
            grapeData.docID = doc.id
            this.grapes.push(grapeData)
            console.log(grapeData)
            this.author = grapeData.sourceAuthor
            this.title = grapeData.grapeTitle
            this.grapeSource = grapeData.grapeSource
            this.image = grapeData.sourceImage
            this.id = grapeData.id
            this.description = grapeData.grapeContent
            if (this.description.indexOf('<p>') < 0) {
              var lines = this.description.split("<br>")
              this.description = '<p>' + lines.join("</p><p>") + '</p>'
              console.log(this.description)
            }
            this.description = vm.replaceGrapeTextSymbols(this.description)
            this.createdTimestamp = grapeData.createdTimestamp
            this.updatedTimestamp = grapeData.updatedTimestamp
            //this.description = $(this.description).text()
            //this.description = this.description.length > 155 ? this.description.substring(0, 150) + '...' : this.description

            setTimeout(function() {
              vm.createShareImage(grapeData)
            }, 1000)
            $('body').removeClass('pace-running')
            $('.pace').removeClass('pace-active')
          })
        })
      },
      replaceGrapeTextSymbols (text) {
        //text = text.replace(/-\s/g, '')
        //text = text.replace(/—/g, '&#8211;')
        text = text.replace(/--/g, '–')
        text = text.replace(/ - /g, '-')
        text = text.replace(/ {2}- {2}/g, ' – ')
        text = text.replace(/ {2}– /g, ' – ')
        text = text.replace(/ – {2}/g, ' – ')
        //text = text.replace(/([a-zA-Z0-9])\-([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure spaces between in-word hyphen */
        text = text.replace(/([a-zA-Z0-9])—([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9])\—([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9])—([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9])–([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9])&#8211;([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9])&#8212;([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/\.([a-zA-Z0-9])/g, '. $1') /* Ensure space after full stop */
        text = text.replace(/\!([a-zA-Z0-9])/g, '! $1') /* Ensure space after exclamation mark */
        text = text.replace(/\?([a-zA-Z0-9])/g, '? $1') /* Ensure space after question mark */
        text = text.replace(/ &#8211;([a-zA-Z0-9])/g, ' &#8211; $1') /* Ensure space after — */
        text = text.replace(/&#8211; ([a-zA-Z0-9])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/— ([a-zA-Z0-9])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/ —([a-zA-Z0-9])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/– ([a-zA-Z0-9])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/ –([a-zA-Z0-9])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/\. \" /g, '.\" ') /* Remove space between full stop and quotemark */
        text = text.replace(/\? \" /g, '?\" ') /* Remove space between question mark and quotemark */
        text = text.replace(/\! \" /g, '!\" ') /* Remove space between exclamation mark and quotemark */
        text = text.replace(/\. \' /g, '.\' ') /* Remove space between full stop and quotemark */
        text = text.replace(/\? \' /g, '?\' ') /* Remove space between question mark and quotemark */
        text = text.replace(/\! \' /g, '!\' ') /* Remove space between exclamation mark and quotemark */
        // text = text.replace(/.\s*([a-z])/g, function(d,e) { return '. ' + e.toUpperCase() }) /* Ensure capital letter after full stop */
        text = text.replace(/ ofa /g, 'of a') /* Change 'ofa' to 'of a' */
        text = text.replace(/ ofthe /g, 'of the') /* Change 'ofa' to 'of a' */
        text = text.replace(/”/g, '\'') /* Change ” to ' */
        text = text.replace(/ {2}/g, ' ') /* Change double spacing to single */
        text = text.replace(/\+>/g, '+ >')
        text = text.replace(/\.{\+}/g, '. <i class="fal fa-genderless"></i>')
        text = text.replace(/\(\+\)/g, '<i class="fal fa-genderless"></i>')
        text = text.replace(/\{\+}/g, '<i class="fal fa-genderless"></i>')
        text = text.replace(/\.\+/g, '. <i class="fal fa-genderless"></i>')
        text = text.replace(/\+/g, '<i class="fal fa-genderless"></i>')
        text = text.replace(/\.{>}/g, '. <i class="fal fa-angle-double-right"></i>')
        text = text.replace(/\{>}/g, '<i class="fal fa-angle-double-right"></i>')
        text = text.replace(/\{&gt;}/g, '<i class="fal fa-angle-double-right"></i>')
        text = text.replace(/\{<}/g, '<i class="fal fa-angle-double-left"></i>')
        text = text.replace(/\{&lt;}/g, '<i class="fal fa-angle-double-left"></i>')
        text = text.replace(/ >/g, ' <i class="fal fa-angle-double-right"></i>')
        text = text.replace(/\. >/g, '. <i class="fal fa-angle-double-right"></i>')
        text = text.replace(/&gt;/g, '<i class="fal fa-angle-double-right"></i>')
        text = text.replace(/ &gt;/g, ' <i class="fal fa-angle-double-right"></i>')
        text = text.replace(/&lt;/g, '<i class="fal fa-angle-double-left"></i>')
        text = text.replace(/><\/i><i/g, '></i> <i')
        return text
      },
      createShareImage (grapeData) {
        let vm = this
        var $share_html = ''
        $share_html += '<div id="grape-' + grapeData.id + '" class="grape-capture-outer">'
        $share_html += '<div class="grape-capture">'
        $share_html += '<h4 class="grape-author">' + grapeData.sourceAuthor + '</h4>'
        $share_html += '<h3 class="grape-title">' + grapeData.grapeTitle + '</h3>'
        $share_html += '<span class="grape-source">' + grapeData.grapeSource + '</span>'
        $share_html += '<div class="grape-content-wrap">'
        $share_html += '<div class="grape-content-preview-overlay"></div>'
        $share_html += '<div class="grape-content">' + vm.description + '</div>'
        $share_html += '</div>'
        $share_html += '<div class="grapevine-link">'
        $share_html += '<a href="https://atgrapevine.com" target="_blank">atgrapevine.com</a>'
        $share_html += '</div>'
        $share_html += '</div>'
        $share_html += '</div>'
        $('#grape-capture-wrap').append($share_html)
        html2canvas(document.querySelector("#grape-capture-wrap"), {allowTaint: false}).then(canvas => {
          $('#share-screenshot').empty()
          $('#share-screenshot').append(canvas)
          var img = canvas.toDataURL("image/jpeg")
          $('#share-screenshot').append('<img src="'+img+'"/>')
          vm.shareImageBlob = vm.getCanvasBlob(canvas)
          vm.shareImageBlob.then(function(blob) {
            //vm.uploadShareImage()
          }, function(err) {
            console.log(err)
          })
        })
      },
      getCanvasBlob (canvas) {
        return new Promise(function (resolve, reject) {
          canvas.toBlob(function (blob) {
            resolve(blob)
          }, 'image/jpeg', 0.95)
        })
      },
      uploadShareImage () {
        let vm = this
        var storageRef = firebase.storage().ref()
        var shareImageRef = storageRef.child('shareImages/' + 'testImage' + '.jpg')
        shareImageRef.put(vm.shareImageBlob).then(function (snapshot) {
          console.log('Uploaded a blob or file!')
        });
      }
    },
    components: {
      Grape
    }
  };
</script>

<style>
  #share-screenshot img {
    max-width: 720px;
  }
  #grape-capture-wrap {
    line-height: 1.4;
    width: 725px;
  }
  .grape-capture-outer {
    padding: 3px 2px 2px 2px;
    max-width: 720px;
    width: 725px;
  }
  .grape-capture {
    padding: 40px 60px;
    box-sizing: border-box;
    clear: both;
    height: auto;
    overflow: hidden;
    border: 5px solid #169a16;
    text-align: center;
    margin-left: 1px;
  }
  .grape-capture p {
    margin-top: 0;
    margin-bottom: 0;
    text-indent: 50px;
  }
  .grape-capture p i {
    text-indent: 1px;
  }
  .grape-capture p:first-child {
    text-indent: 0;
  }
  .grape-capture br {
    display: none;
  }
  .grape-capture .grape-source {
    margin-bottom: 5px;
    font-size: 1.1em;
    color: #169a16;
    font-style: italic;
    text-decoration: none;
    display: inline-block;
    padding: 15px 40px;
    max-width: 80%;
    margin: 0 auto 30px;
    border-top: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
  }
  .grape-capture h4.grape-author {
    text-transform: uppercase;
    font-size: 1.4em;
    font-weight: 400;
    color: #169a16;
    margin: 0 0 10px;
    padding-top: 20px;
  }
  .grape-capture h3.grape-title {
    margin-top: .8em;
    font-size: 1.2em;
    margin-bottom: 20px;
  }
  .grape-capture .grape-center-divide {
    height: 1px;
    width: 50%;
    background: #eee;
    margin-bottom: 30px;
  }
  .grape-capture .grape-content-wrap {
    text-align: left;
    font-size: 1.05em;
  }
  .grape-capture .grape-content-preview-overlay {
    z-index: 1;
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    display: none;
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+100 */
    /* IE9 SVG, needs conditional override of 'filter' to 'none' */
    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2ZmZmZmZiIgc3RvcC1vcGFjaXR5PSIwIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNmZmZmZmYiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+);
    background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); /* FF3.6-15 */
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(255,255,255,0)), color-stop(100%,rgba(255,255,255,1))); /* Chrome4-9,Safari4-5 */
    background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* Chrome10-25,Safari5.1-6 */
    background: -o-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* Opera 11.10-11.50 */
    background: -ms-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* IE10 preview */
    background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 ); /* IE6-8 */
  }
  .grape-capture .grapevine-link a {
    display: inline-block;
    border-top: 1px solid #eaeaea;
    margin: 30px auto 10px;
    padding: 20px 50px;
    color: #169a16;
    text-decoration: none;
    font-weight: 800;
    font-size: 1.1em;
  }
</style>

<style scoped>
  #main-wrap {
    background: #f9f9f9;
    min-height: 100vh;
  }
  h1 {
    font-size: 30px;
    margin: 30px 0;
  }
  p {
    margin-bottom: 20px;
  }
  .contact--section {
    background-color: white;
    padding: 20px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);
    .__name {
      font-size: 30px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ViewGrapeShareImage.vue